import React from 'react'
import Link from '@/components/Common/Link'
import { BrandsData, CompanyDetails } from '@/components/Stocks/Widgets/types'
import CompanyInformation from '@/stories/components/USStocksDetail/CompanyInformation'

const CompanyInfoWrapper = ({
  company_details,
  name,
  brands_data,
  full_name = '',
  strapiAboutSection,
}: {
  company_details?: CompanyDetails | null
  name: string
  brands_data?: BrandsData[] | null
  strapiAboutSection?: string
  full_name?: string
}) => {
  const { info = {}, introduction = '' } = company_details ?? {}
  const { title = '' } = info
  return (
    <CompanyInformation
      containerClass="bg-brand-white !mb-0"
      childClass="!p-0"
      headingClassName="!pb-6 !border-b-[0.5px] w-full lg:text-2xl mb-6"
      desc={title}
      data={{
        title: `About ${name}`,
        description: introduction,
        strapiAboutSection: strapiAboutSection ?? null,
        dataList: [
          { title: 'Organisation', subtitle: full_name },
          {
            title: 'Headquarters',
            subtitle: company_details?.head_quarters ?? '',
          },
          {
            title: 'Industry',
            subtitle: company_details?.industry ?? '',
          },
          {
            title: 'CEO',
            subtitle: company_details?.ceo_name ?? '',
          },
          {
            title: 'Founded',
            subtitle: company_details?.founded ?? '',
          },
          {
            title: 'E-voting on shares',
            subtitle: (
              <Link
                href="https://evoting.cdslindia.com/Evoting/EvotingLogin"
                className="text-brand-blue-azureRadiance"
                openInNewTab
              >
                Click here to vote
              </Link>
            ),
          },
        ],
      }}
      brands_data={brands_data}
    />
  )
}

export default React.memo(CompanyInfoWrapper)
